import VABasicInformation from "../../../../features/bonds/va/components/BasicInformation";
import VAGeneralInformation from "../../../../features/bonds/va/components/GeneralInformation";
import VAPrincipals from "../../../../features/bonds/va/components/Principals";
import VAAttorneyInformation from "../../../../features/bonds/va/components/AttorneyInformation";
import VARequestorInformation from "../../../../features/bonds/va/components/RequestorInformation";
import VADocumentUpload from "../../../../features/bonds/va/components/DocumentUpload";
import { BillingInformationForm } from "../Helpers/BillingInformation";
import { ObligeeInformationForm } from "../Helpers/ObligeeInformation";
import {
  getSelectedStateLabel,
  standardStep,
} from "../bondWizardPageConfig.shared";

export default {
  layout: "standard",
  inlineTitle: () =>
    `VA Bond Request for State of ${getSelectedStateLabel()}`,
  containerClassName: "p-6 max-w-4xl mx-auto",
  guestSupportContext: "Guest VA Bond Request",
  hasDuplicateDialog: false,
  hasEsignatureDialog: true,
  getIsGuest: (form) => form.isGuestRequest,
  supportOnGoBack: ({ setSupportModalOpen, handleStepClick, activeStep }) => () => {
    setSupportModalOpen(false);
    if (activeStep > 0) handleStepClick(0);
  },
  steps: [
    standardStep(VABasicInformation, "basicInformation", (ctx) => ({
      data: ctx.globalState.basicInformation,
      updateData: (data) => ctx.updateGlobalState("basicInformation", data),
      errors: ctx.errors,
    })),
    standardStep(VAGeneralInformation, "generalInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.generalInformation,
      updateData: (data) => ctx.updateGlobalState("generalInformation", data),
      errors: ctx.errors,
    })),
    standardStep(VAPrincipals, "guardianDetails", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.guardianDetails,
      updateData: (data) => ctx.updateGlobalState("guardianDetails", data),
      isGuest: ctx.isGuest,
    })),
    standardStep(VAAttorneyInformation, "attorneyInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.attorneyInformation,
      updateData: (data) => ctx.updateGlobalState("attorneyInformation", data),
      isGuest: ctx.isGuest,
    })),
    standardStep(ObligeeInformationForm, "obligeeInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.obligeeInformation,
      updateData: (data) => ctx.updateGlobalState("obligeeInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
      bondType: "VA",
    })),
    standardStep(VARequestorInformation, "requestorInformation", (ctx) => ({
      data: ctx.globalState.requestorInformation,
      updateData: (data) => ctx.updateGlobalState("requestorInformation", data),
      errors: ctx.errors,
    })),
    standardStep(VADocumentUpload, "documentUpload", (ctx) => ({
      data: ctx.globalState.documentUpload,
      updateData: (data) => ctx.updateGlobalState("documentUpload", data),
    })),
    standardStep(BillingInformationForm, "billingInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.billingInformation,
      updateData: (data) => ctx.updateGlobalState("billingInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
      isGuest: ctx.isGuest,
    })),
  ],
};
